import React from 'react';
import { ArrowDown, ArrowUp, Shuffle } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

const reseed = (teams) => teams.map((t, i) => ({ ...t, seed: i + 1 }));

// Seed order = team order. Changing seeds resets any hand-made matchups to standard seeding.
export const SeedingList = ({ teams, setEventData }) => {
  const apply = (next) => setEventData((p) => ({ ...p, teams: reseed(next), bracket_positions: null }));
  const move = (i, d) => {
    const next = [...teams];
    [next[i], next[i + d]] = [next[i + d], next[i]];
    apply(next);
  };
  const draw = () => {
    const next = [...teams];
    for (let i = next.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [next[i], next[j]] = [next[j], next[i]];
    }
    apply(next);
    toast.success('Random draw done', { description: 'Seeds were shuffled. Draw again or move teams by hand.' });
  };
  return (
    <div className="space-y-3" data-testid="bracket-seeding">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <p className="text-sm text-slate-600 max-w-md">
          Seed 1 is your top-ranked team and top seeds get any byes. Teams start in the order you entered them, so move them to match your rankings, or use a random draw for an unseeded event.
        </p>
        <Button type="button" variant="outline" size="sm" onClick={draw} data-testid="bracket-random-draw-btn"><Shuffle className="w-4 h-4 mr-1.5" />Random draw</Button>
      </div>
      <ol className="divide-y divide-slate-100 border border-slate-200 rounded-lg max-h-80 overflow-y-auto">
        {teams.map((t, i) => (
          <li key={t.id} className="flex items-center gap-3 px-3 py-1.5" data-testid={`bracket-seed-row-${i + 1}`}>
            <span className="w-7 h-7 rounded-full bg-[#00247D] text-white text-xs font-bold flex items-center justify-center shrink-0">{i + 1}</span>
            <span className="flex-1 min-w-0 truncate font-medium text-slate-800">{t.name}</span>
            <Button type="button" variant="ghost" size="icon" className="h-7 w-7" disabled={i === 0} onClick={() => move(i, -1)} aria-label={`Move ${t.name} up`} data-testid={`bracket-seed-up-${i + 1}`}><ArrowUp className="w-4 h-4" /></Button>
            <Button type="button" variant="ghost" size="icon" className="h-7 w-7" disabled={i === teams.length - 1} onClick={() => move(i, 1)} aria-label={`Move ${t.name} down`} data-testid={`bracket-seed-down-${i + 1}`}><ArrowDown className="w-4 h-4" /></Button>
          </li>
        ))}
      </ol>
    </div>
  );
};
